import React from "react";
import radius from "../theme/radius";
import shadows from "../theme/shadows";
import typography from "../theme/typography";

const variantMap = {
  info: {
    background: "rgba(59,130,246,0.10)",
    borderColor: "rgba(59,130,246,0.22)",
    color: "#1E3A8A",
  },
  success: {
    background: "rgba(34,197,94,0.10)",
    borderColor: "rgba(34,197,94,0.22)",
    color: "#166534",
  },
  warning: {
    background: "rgba(245,158,11,0.10)",
    borderColor: "rgba(245,158,11,0.22)",
    color: "#92400E",
  },
  error: {
    background: "rgba(239,68,68,0.10)",
    borderColor: "rgba(239,68,68,0.22)",
    color: "#991B1B",
  },
};

export default function FeedbackBanner({
  children,
  text,
  variant = "info",
  centered = true,
  style = {},
  className = "",
}) {
  const palette = variantMap[variant] || variantMap.info;
  const content = text ?? children;

  if (!content) return null;

  return (
    <div
      className={className}
      style={{
        width: "100%",
        borderRadius: radius.xl,
        border: `1px solid ${palette.borderColor}`,
        background: palette.background,
        color: palette.color,
        padding: "12px 14px",
        textAlign: centered ? "center" : "left",
        fontFamily: typography.fontFamily,
        fontSize: typography.size.sm,
        fontWeight: typography.weight.semibold,
        lineHeight: typography.lineHeight.sm,
        boxShadow: shadows.soft,
        boxSizing: "border-box",
        ...style,
      }}
    >
      {content}
    </div>
  );
}